import { patientActions, userActions } from '_actions'
import { createReducer } from '@reduxjs/toolkit'

const initialState = {
};

export const reducer = createReducer(initialState, {
    [patientActions.loadSuccess]: (state, action) => {
        var admits = {};

        Object.values(action.payload.entities.admissions).forEach(x => {
            admits[x.id] = {
                id: x.id,
                ptno: x.ptno,
                visible: x.dischargeDate === null ? true : false,
                therapistRefreshing: false
            };
        });

        state = { ...state, ...admits };

        return state;
    },
    [userActions.loadSessionSuccess]: (state, action) => {
        var admits = {};

        if (action.payload.patientsContainer.entities.admissions) {

            Object.values(action.payload.patientsContainer.entities.admissions).forEach(x => {
                admits[x.id] = {
                    id: x.id,
                    ptno: x.ptno,
                    visible: x.dischargeDate === null ? true : false,
                    therapistRefreshing: false

                };
            });
        }
        state = { ...state, ...admits, ...action.payload.ui.cdv };
        return state;
    },
    [patientActions.closeSuccess]: (state, action) => {
        return Object.values(state).forEach(x => {
            if (x.ptno === action.payload) {
                delete state[x.id];
            }
        })
    },
    [patientActions.toggleCdvVisibility]: (state, action) => {
        state[action.payload].visible = !state[action.payload].visible
    },

    [patientActions.updateSupervisiorRequest]: (state, action) => {
        state[action.payload.epno].therapistRefreshing = true;
    },

    [patientActions.updateSupervisiorSuccess]: (state, action) => {
        state[action.payload.epno].therapistRefreshing = false;
    }
})


